import { AIAgentDetail } from "modules/aiAgents";

const AIAgentDetailPage = () => {
  return <AIAgentDetail />;
};

export default AIAgentDetailPage;
